import { useNavigate } from "react-router-dom";
import InputForm from "../../componentes/input/input";
import {  useState } from "react";
import UsuarioService from "../../services/resource/usuarioService";
import LOGO from '../../assets/logo.png'
import Button from "../../componentes/button/button";


function SolicitarResetSenha() {
    const navigate = useNavigate();
    const service  = new UsuarioService();

    const [email,   setEmail]   = useState("");
    const [loading, setLoading] = useState(false);
    const [erro,    setErro]    = useState("");

    const solicitar = (e) => {
        e.preventDefault();
        setErro("");

        if (!email.trim()) { setErro("Informe um e-mail válido."); return; }

        setLoading(true);
        service.solicitarResetSenha(email)
            .then(() => navigate("/redefinir-senha/" + email))
            .catch((err) => setErro(err.response?.data?.message || "Erro ao solicitar redefinição."))
            .finally(() => setLoading(false));
    };

    return (
        <AuthShell>
            <AuthLogo />

            <div className="text-center mb-6">
                <div className="inline-flex items-center justify-center w-11 h-11 rounded-full bg-accent border border-primary/20 mb-3">
                    <i className="fa fa-key text-primary text-base" />
                </div>
                <h1 className="font-display text-base font-semibold text-foreground">Recuperar acesso</h1>
                <p className="text-xs text-muted-foreground mt-1">
                    Informe seu e-mail e enviaremos um código de verificação.
                </p>
            </div>

            <form onSubmit={solicitar} className="flex flex-col gap-4">
                <Field label="E-mail" icon="fa-envelope">
                    <input
                        type="email"
                        autoComplete="email"
                        placeholder="seu@email.com"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        className="auth-input pl-9"
                    />
                </Field>

                <ErrorMsg msg={erro} />

                <SubmitBtn loading={loading} label="Enviar código" icon="fa-paper-plane" />
            </form>

            <BackLink onClick={() => navigate("/login")} />
        </AuthShell>
    );
}

export default SolicitarResetSenha;

// ─── Componentes compartilhados ───────────────────────────────────────────────
/** Wrapper de página — mesmo card do Login */
function AuthShell({ children }) {
    return (
        <div className="min-h-screen flex items-center justify-center bg-background px-4 py-10">
            <div className="w-full max-w-md bg-card rounded-2xl border border-border p-8 flex flex-col shadow-pop">
                {children}
            </div>
        </div>
    );
}

/** Logo centralizada */
function AuthLogo() {
    return (
        <div className="flex justify-center mb-6">
            <img src={LOGO} alt="Logo Distribuidora York" className="h-10 w-auto object-contain" />
        </div>
    );
}

/**
 * Campo de formulário com ícone à esquerda e, opcionalmente,
 * botão de mostrar/ocultar senha à direita.
 */
function Field({ label, icon, children, onToggle, show }) {
    return (
        <div className="flex flex-col gap-1.5">
            <label className="text-xs font-medium text-muted-foreground">{label}</label>
            <div className="relative">
                <i className={`fa ${icon} absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground text-sm pointer-events-none`} />
                {children}
                {onToggle && (
                    <button
                        type="button"
                        aria-label={show ? "Ocultar senha" : "Mostrar senha"}
                        onClick={onToggle}
                        className="absolute right-2.5 top-1/2 -translate-y-1/2 text-muted-foreground hover:text-foreground transition-colors duration-150 p-1"
                    >
                        <i className={`fa ${show ? "fa-eye-slash" : "fa-eye"} text-sm`} />
                    </button>
                )}
            </div>
        </div>
    );
}

/** Mensagem de erro padronizada */
function ErrorMsg({ msg }) {
    if (!msg) return null;
    return (
        <div className="flex items-start gap-2.5 px-3 py-2.5 rounded-lg bg-destructive/5 border border-destructive/20">
            <i className="fa fa-exclamation-circle text-destructive text-sm mt-0.5 flex-shrink-0" />
            <p className="text-xs text-destructive leading-snug">{msg}</p>
        </div>
    );
}

/** Botão de submit com estado de loading */
function SubmitBtn({ loading, label, icon }) {
    return (
        <button
            type="submit"
            disabled={loading}
            className="w-full flex items-center justify-center gap-2 py-2.5 px-4 rounded-lg bg-primary hover:brightness-95 text-primary-foreground text-sm font-medium shadow-xs transition-all duration-150 disabled:opacity-60 disabled:cursor-not-allowed"
        >
            {loading
                ? <><i className="fa fa-spinner fa-spin text-sm" />Aguarde...</>
                : <><i className={`fa ${icon} text-sm`} />{label}</>
            }
        </button>
    );
}

/** Link "Voltar ao login" */
function BackLink({ onClick, label = "Voltar ao login" }) {
    return (
        <button
            type="button"
            onClick={onClick}
            className="mt-5 w-full text-center text-xs text-muted-foreground hover:text-foreground transition-colors duration-150 flex items-center justify-center gap-1.5"
        >
            <i className="fa fa-arrow-left text-[10px]" />
            {label}
        </button>
    );
}
